import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import cardsReducer from './cardsSlice';
import chartReducer from './chartSlice';
import instrumentsReducer from './instrumentsSlice';
import settingsReducer from './settingsSlice';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        cards: cardsReducer,
        chart: chartReducer,
        instruments: instrumentsReducer,
        settings: settingsReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
